import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function listCompanies(customer_id) {
  const path = `crm/companies/list_to_select/${customer_id}`;
  const companies = await laravelAxios.get(path);
  return companies;
}

export default listCompanies;
